   <!--begin::Users group-->

   <div class="symbol-group symbol-hover gap-2 flex-wrap mx-0">
    <ng-container *ngFor="let user of users; let i=index">
    <div
    *ngIf="!user?.avatar"
      class="symbol symbol-circle symbol-{{_width}} hover-scale m-0"
      ngxTippy="{{user.firstname}} {{user.lastname}}"
    >
      <span class="symbol-label bg-dark text-inverse-dark fw-bold"
        >
        @if (!!user?.firstname) {
        {{user?.firstname[0]}}
      }
        </span
      >
    </div>
    <div
    *ngIf="!!user?.avatar"
      class="symbol symbol-circle symbol-{{_width}} me-6 mb-2 "
      ngxTippy="{{user.firstname}} {{user.lastname}}"
    >
      <img
        alt="Pic"
        src="/assets/media/avatars/300-11.jpg"
      />
    </div>
  </ng-container>
    </div>

